/*
  SylverCar — module de recherche.

  La question posee au visiteur est « Ou est-ce que je vous emmene ? », pas
  « Quels produits avez-vous ? ». A vide, le module ne montre donc AUCUN
  produit : des puces et des besoins, qui menent tous a une collection. A la
  saisie, il montre quatre produits, trois categories, et le lien vers tous les
  resultats.

  Source des resultats : l'API de recherche predictive de Shopify. Le score de
  pertinence reste celui de Shopify ; la couche de synonymes ENRICHIT (elle
  ajoute des produits de collections voisines apres les meilleurs resultats du
  moteur), elle ne le remplace pas.

  Rien de ce qui est du contenu n'est ecrit ici : puces, besoins, synonymes,
  liste blanche, exclusions viennent de snippets/sylvercar-search-config.liquid,
  lues dans <script id="sc-recherche-config">.

  Amelioration progressive : si ce fichier ne se charge pas, la loupe reste un
  vrai lien vers /search, et le tiroir natif de Kalles fonctionne.
*/
(function () {
  'use strict';

  var racine = document.querySelector('[data-sc-rech]');
  var cfgEl = document.getElementById('sc-recherche-config');
  if (!racine || !cfgEl) return;

  var CFG;
  try { CFG = JSON.parse(cfgEl.textContent); } catch (e) { return; }

  var champ = racine.querySelector('[data-sc-rech-champ]');
  var form = racine.querySelector('[data-sc-rech-form]');
  var btnEffacer = racine.querySelector('[data-sc-rech-effacer]');
  var corps = racine.querySelector('[data-sc-rech-corps]');
  var zoneVide = racine.querySelector('[data-sc-rech-vide]');
  var zoneRes = racine.querySelector('[data-sc-rech-resultats]');
  var statut = racine.querySelector('[data-sc-rech-statut]');
  var listePuces = racine.querySelector('[data-sc-rech-puces]');
  var listeBesoins = racine.querySelector('[data-sc-rech-besoins]');
  var groupePuces = racine.querySelector('[data-sc-rech-groupe-puces]');
  var groupeBesoins = racine.querySelector('[data-sc-rech-groupe-besoins]');
  var ligneCadeau = racine.querySelector('[data-sc-rech-cadeau]');

  var COL = CFG.collections || {};
  var LIBELLES = CFG.libelles || {};
  var EXCL = CFG.exclusions || {};
  var NB_PRODUITS = 4;
  var NB_CATEGORIES = 3;
  var SEUIL_CARACTERES = 2;
  var DELAI_FRAPPE = 250;
  var CONSERVATION_SAISIE = 5 * 60 * 1000;   // « fermeture / reouverture immediate »

  var ouvert = false;
  var declencheur = null;
  var minuteur = null;
  var numeroRequete = 0;
  var derniereSaisieRendue = null;
  var saisieConservee = '';
  var fermeLe = 0;
  var cacheSuggest = {};
  var cacheCollections = {};
  var cacheNotes = {};
  var observateur = null;

  var ICONE_FLECHE = '<svg viewBox="0 0 16 16" aria-hidden="true" focusable="false"><path d="M6 2l6 6-6 6" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg>';

  /* ------------------------------------------------------------------ */
  /* Outils                                                              */
  /* ------------------------------------------------------------------ */
  function echapper(t) {
    return String(t == null ? '' : t).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  // Minuscules, sans accents, tirets et apostrophes comptes comme des espaces.
  // C'est la forme sous laquelle on compare ET sous laquelle on interroge
  // Shopify : « telephone », « Téléphone » et « TÉLÉPHONE » valent la meme chose.
  function normaliser(s) {
    return String(s || '')
      .normalize('NFD').replace(/[̀-ͯ]/g, '')
      .toLowerCase()
      .replace(/[’'`\-_]/g, ' ')
      .replace(/[^a-z0-9\s]/g, ' ')
      .replace(/\s+/g, ' ')
      .trim();
  }

  function libelleCollection(handle) {
    return LIBELLES[handle] || (COL[handle] && COL[handle].titre) || handle;
  }

  function evenement(nom, donnees) {
    if (racine.getAttribute('data-analytics') !== '1') return;
    try {
      window.dataLayer = window.dataLayer || [];
      var charge = { event: nom };
      for (var k in donnees) if (Object.prototype.hasOwnProperty.call(donnees, k)) charge[k] = donnees[k];
      window.dataLayer.push(charge);
    } catch (e) { /* le suivi ne doit jamais gener la recherche */ }
  }

  function euros(valeur) {
    var n = parseFloat(valeur);
    if (isNaN(n)) return '';
    return n.toFixed(2).replace('.', ',') + ' €';
  }

  /* ------------------------------------------------------------------ */
  /* Tolerance aux fautes                                                */
  /* ------------------------------------------------------------------ */
  // Vocabulaire : ce que la boutique vend et ce que ses regles savent
  // reconnaitre. Une faute n'est corrigee QUE vers l'un de ces mots, jamais
  // vers un mot quelconque : mieux vaut laisser « lombere » tel quel si rien
  // de proche n'existe que le transformer en autre chose.
  var VOCAB = (function () {
    var ensemble = {};
    function ajouter(texte) {
      normaliser(texte).split(' ').forEach(function (m) { if (m.length >= 3) ensemble[m] = true; });
    }
    (CFG.vocabulaire || []).forEach(ajouter);
    (CFG.synonymes || []).forEach(function (r) { (r.mots || []).forEach(ajouter); });
    Object.keys(LIBELLES).forEach(function (h) { ajouter(LIBELLES[h]); });
    return Object.keys(ensemble);
  })();
  var EST_VOCAB = {};
  VOCAB.forEach(function (m) { EST_VOCAB[m] = true; });

  // Distance de Damerau-Levenshtein (la transposition « lmobaire » compte pour 1).
  function distance(a, b) {
    var la = a.length, lb = b.length, d = [], i, j;
    for (i = 0; i <= la; i++) { d[i] = [i]; }
    for (j = 1; j <= lb; j++) { d[0][j] = j; }
    for (i = 1; i <= la; i++) {
      for (j = 1; j <= lb; j++) {
        var cout = a.charAt(i - 1) === b.charAt(j - 1) ? 0 : 1;
        d[i][j] = Math.min(d[i - 1][j] + 1, d[i][j - 1] + 1, d[i - 1][j - 1] + cout);
        if (i > 1 && j > 1 && a.charAt(i - 1) === b.charAt(j - 2) && a.charAt(i - 2) === b.charAt(j - 1)) {
          d[i][j] = Math.min(d[i][j], d[i - 2][j - 2] + 1);
        }
      }
    }
    return d[la][lb];
  }

  function corrigerMot(mot) {
    if (mot.length < 4 || EST_VOCAB[mot]) return mot;
    // Mot en cours de frappe : « lomb » est le debut de « lombaire », pas une faute.
    for (var p = 0; p < VOCAB.length; p++) if (VOCAB[p].indexOf(mot) === 0) return mot;
    var seuil = mot.length <= 5 ? 1 : 2;
    var meilleur = null, meilleureDistance = seuil + 1;
    for (var i = 0; i < VOCAB.length; i++) {
      var cand = VOCAB[i];
      if (Math.abs(cand.length - mot.length) > seuil) continue;
      var dist = distance(mot, cand);
      if (dist < meilleureDistance) { meilleureDistance = dist; meilleur = cand; }
    }
    return meilleur || mot;
  }

  function corrigerRequete(saisie) {
    return normaliser(saisie).split(' ').filter(Boolean).map(corrigerMot).join(' ');
  }

  /* ------------------------------------------------------------------ */
  /* Synonymes                                                           */
  /* ------------------------------------------------------------------ */
  // Un declencheur correspond s'il est present comme MOT ENTIER (ou expression
  // entiere), ou — pour un mot seul de 4 lettres ou plus — s'il commence par
  // ce que le visiteur est en train de taper (« sciat » -> « sciatique »).
  function declencheurCorrespond(requete, mot) {
    var m = normaliser(mot);
    var phrase = ' ' + requete + ' ';
    if (phrase.indexOf(' ' + m + ' ') !== -1) return true;
    if (m.indexOf(' ') === -1) {
      var morceaux = requete.split(' ');
      var dernier = morceaux[morceaux.length - 1];
      if (dernier.length >= 4 && m.indexOf(dernier) === 0) return true;
    }
    return false;
  }

  function reglesCorrespondantes(requete) {
    var trouvees = [];
    (CFG.synonymes || []).forEach(function (regle) {
      for (var i = 0; i < (regle.mots || []).length; i++) {
        if (declencheurCorrespond(requete, regle.mots[i])) { trouvees.push(regle); return; }
      }
    });
    return trouvees;
  }

  /* ------------------------------------------------------------------ */
  /* Donnees                                                             */
  /* ------------------------------------------------------------------ */
  function suggest(q) {
    if (cacheSuggest[q]) return cacheSuggest[q];
    var url = '/search/suggest.json?q=' + encodeURIComponent(q) +
      '&resources[type]=product,collection&resources[limit]=10&resources[limit_scope]=each' +
      '&resources[options][unavailable_products]=last&resources[options][prefix]=last';
    cacheSuggest[q] = fetch(url, { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
      .then(function (r) { if (!r.ok) throw new Error('recherche ' + r.status); return r.json(); })
      .then(function (j) {
        var res = (j && j.resources && j.resources.results) || {};
        return { produits: res.products || [], collections: res.collections || [] };
      })
      .catch(function (e) { delete cacheSuggest[q]; throw e; });
    return cacheSuggest[q];
  }

  // Enrichissement par synonyme : les produits de la COLLECTION que la regle
  // designe, dans l'ordre choisi par le marchand (glisser-deposer dans l'admin).
  //
  // On n'elargit PAS par une seconde recherche texte. Mesure du 04/10/2026 :
  // « coussin rehausseur » ramenait des coussins lombaires, parce que le moteur
  // rapproche aussi les produits qui ne portent que « coussin ». Or la colonne
  // « Doit remonter » du brief est, ligne apres ligne, une collection : c'est
  // elle la source fiable. Un produit absent de la collection ne peut donc pas
  // s'inviter dans les resultats par le seul hasard d'un mot commun.
  function produitsDeCollection(handle) {
    if (cacheCollections[handle]) return cacheCollections[handle];
    cacheCollections[handle] = fetch('/collections/' + encodeURIComponent(handle) + '/products.json?limit=12',
      { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
      .then(function (r) { if (!r.ok) throw new Error('collection ' + r.status); return r.json(); })
      .then(function (j) {
        return ((j && j.products) || []).map(function (p) {
          var vs = p.variants || [];
          var prix = vs.map(function (v) { return parseFloat(v.price); }).filter(function (n) { return !isNaN(n); });
          var barres = vs.map(function (v) { return parseFloat(v.compare_at_price) || 0; });
          var image = (p.images && p.images[0] && p.images[0].src) || (p.image && p.image.src) || '';
          return {
            id: p.id, handle: p.handle, title: p.title, url: '/products/' + p.handle,
            tags: p.tags || [], type: p.product_type || '',
            featured_image: { url: image }, image: image,
            price: prix.length ? Math.min.apply(null, prix) : NaN,
            price_min: prix.length ? Math.min.apply(null, prix) : NaN,
            price_max: prix.length ? Math.max.apply(null, prix) : NaN,
            compare_at_price_max: barres.length ? Math.max.apply(null, barres) : 0,
            disponible: vs.some(function (v) { return v.available; })
          };
        }).filter(function (p) { return p.disponible; });
      })
      .catch(function (e) { delete cacheCollections[handle]; throw e; });
    return cacheCollections[handle];
  }

  // Niveau 2 de la regle d'exclusion. Le niveau 1 (seo.hidden = 1) retire deja
  // les produits techniques de l'index ; ce filtre est la ceinture portee avec
  // les bretelles : si un produit technique reapparait un jour, il ne remonte
  // quand meme jamais.
  function admissible(p) {
    var tags = (p.tags || []).map(function (t) { return String(t).toLowerCase(); });
    for (var i = 0; i < (EXCL.tags || []).length; i++) {
      if (tags.indexOf(EXCL.tags[i]) !== -1) return false;
    }
    var type = String(p.type || '').toLowerCase();
    if ((EXCL.types || []).indexOf(type) !== -1) return false;
    var handle = String(p.handle || '');
    for (var j = 0; j < (EXCL.prefixes_handle || []).length; j++) {
      if (handle.indexOf(EXCL.prefixes_handle[j]) === 0) return false;
    }
    return true;
  }

  function versProduit(p) {
    // TOUJOURS l'image principale du produit (featured_image = premiere image).
    // Jamais l'image d'une variante, jamais la deuxieme, jamais d'image de
    // survol : c'est ce qui avait pose probleme sur PaniHome.
    var image = (p.featured_image && p.featured_image.url) || p.image || '';
    var prix = parseFloat(p.price);
    var prixMin = parseFloat(p.price_min != null ? p.price_min : p.price);
    var prixMax = parseFloat(p.price_max != null ? p.price_max : p.price);
    var barre = parseFloat(p.compare_at_price_max);
    return {
      id: p.id,
      handle: p.handle,
      titre: p.title,
      url: p.url,
      image: image,
      prix: isNaN(prixMin) ? prix : prixMin,
      // Plusieurs prix : « des X € ». Un seul : prix, et prix barre s'il existe.
      aPartirDe: !isNaN(prixMin) && !isNaN(prixMax) && prixMin < prixMax,
      prixBarre: (!isNaN(barre) && barre > prixMax && prixMin === prixMax) ? barre : null
    };
  }

  // 4 produits. Sans synonyme : les 4 premiers du moteur. Avec synonyme : les 2
  // premiers du moteur — son score fait foi — puis ceux des collections
  // voisines, puis le reste du moteur. Ainsi la couche enrichit sans jamais
  // evincer ce que Shopify juge le plus pertinent.
  function composer(principal, expansions) {
    var vus = {}, sortie = [];
    function pousser(liste, max) {
      for (var i = 0; i < liste.length && sortie.length < max; i++) {
        var p = liste[i];
        if (vus[p.id]) continue;
        vus[p.id] = true;
        sortie.push(p);
      }
    }
    var principaux = principal.filter(admissible).map(versProduit);
    var enrichis = [];
    // tourniquet entre les expansions : une regle ne monopolise pas les places
    var max = 0;
    expansions.forEach(function (e) { max = Math.max(max, e.length); });
    for (var k = 0; k < max; k++) {
      expansions.forEach(function (e) { if (e[k]) enrichis.push(e[k]); });
    }
    enrichis = enrichis.filter(admissible).map(versProduit);

    if (!enrichis.length) { pousser(principaux, NB_PRODUITS); return sortie; }
    pousser(principaux, 2);
    pousser(enrichis, NB_PRODUITS);
    pousser(principaux, NB_PRODUITS);
    return sortie;
  }

  // Categories : celles que designent les regles d'abord (fiables), puis celles
  // que Shopify rapproche de la saisie. TOUTES passent par la liste blanche, et
  // la liste blanche ne contient que des collections publiees et non vides.
  function composerCategories(regles, collectionsMoteur) {
    var vues = {}, sortie = [];
    function ajouter(handle) {
      if (!COL[handle] || vues[handle] || sortie.length >= NB_CATEGORIES) return;
      vues[handle] = true;
      sortie.push(handle);
    }
    regles.forEach(function (r) { ajouter(r.collection); });
    collectionsMoteur.forEach(function (c) { ajouter(c.handle); });
    return sortie;
  }

  function chercher(saisie) {
    var requete = corrigerRequete(saisie).slice(0, 80);
    var regles = reglesCorrespondantes(requete);
    // Deux regles au plus alimentent l'enrichissement : au-dela, la liste
    // deviendrait un melange de tout et de rien.
    var cibles = [];
    regles.forEach(function (r) {
      if (COL[r.collection] && cibles.indexOf(r.collection) === -1) cibles.push(r.collection);
    });
    cibles = cibles.slice(0, 2);

    var demandes = [suggest(requete)].concat(cibles.map(produitsDeCollection));
    return Promise.all(demandes.map(function (p) {
      return p.then(function (v) { return v; }, function () { return null; });
    })).then(function (reponses) {
      // Le moteur est la source principale : s'il est muet ET qu'aucune
      // collection n'a repondu, c'est une vraie panne.
      if (!reponses[0] && !reponses.slice(1).some(Boolean)) throw new Error('indisponible');
      var principal = reponses[0] ? reponses[0].produits : [];
      var collectionsMoteur = reponses[0] ? reponses[0].collections : [];
      var listesExp = reponses.slice(1).filter(Boolean);
      return {
        requete: requete,
        produits: composer(principal, listesExp),
        categories: composerCategories(regles, collectionsMoteur)
      };
    });
  }

  // Avis Judge.me : une vue JSON par produit, mise en cache. Les etoiles ne
  // s'affichent QUE si le produit a au moins un avis.
  function noteDe(handle) {
    if (cacheNotes[handle]) return cacheNotes[handle];
    cacheNotes[handle] = fetch('/products/' + encodeURIComponent(handle) + '?view=recherche', { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (j) { return j && j.avis > 0 ? j : null; })
      .catch(function () { return null; });
    return cacheNotes[handle];
  }

  /* ------------------------------------------------------------------ */
  /* Rendu                                                               */
  /* ------------------------------------------------------------------ */
  function lienCollection(handle, classe, evt, source) {
    return '<a class="' + classe + '" href="' + echapper(COL[handle].url) + '"' +
      ' data-sc-evt="' + evt + '" data-collection="' + echapper(handle) + '"' +
      (source ? ' data-source="' + source + '"' : '') + '>' +
      '<span>' + echapper(libelleCollection(handle)) + '</span>' + ICONE_FLECHE + '</a>';
  }

  function rendreEtatVide() {
    var puces = (CFG.puces || []).filter(function (p) { return COL[p.collection]; });
    var besoins = (CFG.besoins || []).filter(function (b) { return COL[b.collection]; });

    listePuces.innerHTML = puces.map(function (p) {
      return '<li><a class="sc-rech__puce" href="' + echapper(COL[p.collection].url) + '"' +
        ' data-sc-evt="collection" data-source="puce" data-collection="' + echapper(p.collection) + '">' +
        echapper(p.libelle) + '</a></li>';
    }).join('');
    listeBesoins.innerHTML = besoins.map(function (b) {
      return '<li><a class="sc-rech__besoin" href="' + echapper(COL[b.collection].url) + '"' +
        ' data-sc-evt="besoin" data-besoin="' + echapper(b.libelle) + '" data-collection="' + echapper(b.collection) + '">' +
        '<span>' + echapper(b.libelle) + '</span>' + ICONE_FLECHE + '</a></li>';
    }).join('');

    // Remplissage par colonne sur desktop : la colonne de gauche prend la moitie haute.
    listeBesoins.style.setProperty('--sc-rech-lignes', String(Math.max(1, Math.ceil(besoins.length / 2))));

    // Un groupe sans aucun lien valide disparait : jamais de titre au-dessus du vide.
    groupePuces.hidden = !puces.length;
    groupeBesoins.hidden = !besoins.length;

    if (CFG.cadeau) { ligneCadeau.textContent = CFG.cadeau; ligneCadeau.hidden = false; }
  }

  function carteProduit(p) {
    var vignette = '';
    if (p.image) {
      var src = p.image + (p.image.indexOf('?') !== -1 ? '&' : '?') + 'width=160';
      vignette = '<img src="' + echapper(src) + '" width="72" height="72" loading="lazy" decoding="async" alt="">';
    }
    var prix = '<span class="sc-rech__prix">' +
      (p.aPartirDe ? '<small>dès</small>' : '') + '<span>' + euros(p.prix) + '</span>' +
      (p.prixBarre ? '<s>' + euros(p.prixBarre) + '</s>' : '') + '</span>';
    return '<li><a class="sc-rech__carte" href="' + echapper(p.url) + '"' +
      ' data-sc-evt="produit" data-handle="' + echapper(p.handle) + '">' +
      '<span class="sc-rech__vignette">' + vignette + '</span>' +
      '<span class="sc-rech__infos">' +
        '<span class="sc-rech__nom">' + echapper(p.titre) + '</span>' +
        '<span class="sc-rech__avis" data-sc-avis="' + echapper(p.handle) + '"></span>' +
        prix +
      '</span></a></li>';
  }

  function tronquer(texte, max) {
    return texte.length > max ? texte.slice(0, max - 1) + '…' : texte;
  }

  function rendreResultats(saisie, donnees) {
    var affichee = tronquer(saisie, 60);
    var html = '';

    if (!donnees.produits.length && !donnees.categories.length) {
      html += '<p class="sc-rech__aucun">Nous n’avons pas trouvé de résultat exact pour “' + echapper(affichee) + '”. ' +
        'Essayez une catégorie ou un type d’accessoire.</p>';
      var secours = (CFG.secours || []).filter(function (s) { return COL[s.collection]; });
      if (secours.length) {
        html += '<div class="sc-rech__groupe"><ul class="sc-rech__liste sc-rech__puces">' +
          secours.map(function (s) {
            return '<li><a class="sc-rech__puce" href="' + echapper(COL[s.collection].url) + '"' +
              ' data-sc-evt="collection" data-source="secours" data-collection="' + echapper(s.collection) + '">' +
              echapper(s.libelle) + '</a></li>';
          }).join('') + '</ul></div>';
      }
      html += '<a class="sc-rech__aide" href="' + echapper(CFG.contact_url) + '" data-sc-evt="aide">Besoin d’aide pour choisir ?</a>';
      zoneRes.innerHTML = html;
      evenement('search_no_result', { search_term: saisie });
      statut.textContent = 'Aucun résultat exact.';
      return;
    }

    if (donnees.produits.length) {
      html += '<section class="sc-rech__groupe"><h2 class="sc-rech__etiquette">Produits</h2>' +
        '<ul class="sc-rech__liste sc-rech__produits">' + donnees.produits.map(carteProduit).join('') + '</ul></section>';
    }
    if (donnees.categories.length) {
      html += '<section class="sc-rech__groupe"><h2 class="sc-rech__etiquette">Catégories</h2>' +
        '<ul class="sc-rech__liste sc-rech__cats">' + donnees.categories.map(function (h) {
          return '<li>' + lienCollection(h, 'sc-rech__cat', 'collection', 'suggestion') + '</li>';
        }).join('') + '</ul></section>';
    }
    html += '<a class="sc-rech__tout" data-sc-evt="tout" href="' +
      echapper(CFG.recherche_url + '?q=' + encodeURIComponent(donnees.requete) + '&type=product') + '">' +
      'Voir tous les résultats pour “' + echapper(affichee) + '” →</a>';

    zoneRes.innerHTML = html;
    statut.textContent = donnees.produits.length + ' produit(s) et ' + donnees.categories.length + ' catégorie(s) proposés.';
    evenement('search_query', { search_term: saisie, results_count: donnees.produits.length });

    // Etoiles : apres coup, dans une ligne a hauteur reservee.
    donnees.produits.forEach(function (p) {
      noteDe(p.handle).then(function (n) {
        if (!n) return;
        var cible = zoneRes.querySelector('[data-sc-avis="' + p.handle + '"]');
        if (!cible) return;
        var pct = Math.max(0, Math.min(100, (parseFloat(n.note) / 5) * 100));
        cible.innerHTML = '<span class="sc-rech__etoiles" style="--p:' + pct.toFixed(0) + '%" role="img" ' +
          'aria-label="Note de ' + String(n.note).replace('.', ',') + ' sur 5"></span><span>(' + n.avis + ')</span>';
      });
    });
  }

  function montrerVide() {
    zoneRes.hidden = true;
    zoneRes.innerHTML = '';
    zoneVide.hidden = false;
    derniereSaisieRendue = null;
    statut.textContent = '';
  }

  function actualiser() {
    var saisie = champ.value.trim();
    btnEffacer.hidden = !champ.value.length;
    if (saisie.length < SEUIL_CARACTERES) { numeroRequete++; corps.classList.remove('is--charge'); montrerVide(); return; }
    if (saisie === derniereSaisieRendue) return;

    var mien = ++numeroRequete;
    corps.classList.add('is--charge');
    chercher(saisie).then(function (donnees) {
      if (mien !== numeroRequete) return;      // une saisie plus recente a pris la main
      derniereSaisieRendue = saisie;
      zoneVide.hidden = true;
      zoneRes.hidden = false;
      rendreResultats(saisie, donnees);
      corps.scrollTop = 0;
    }).catch(function () {
      if (mien !== numeroRequete) return;
      // Panne reseau : jamais d'impasse, memes collections de secours.
      derniereSaisieRendue = null;
      zoneVide.hidden = true;
      zoneRes.hidden = false;
      rendreResultats(saisie, { requete: saisie, produits: [], categories: [] });
    }).then(function () {
      if (mien === numeroRequete) corps.classList.remove('is--charge');
    });
  }

  /* ------------------------------------------------------------------ */
  /* Mesures : hauteur du header, clavier mobile                          */
  /* ------------------------------------------------------------------ */
  function elementHeader() {
    return document.getElementById('shopify-section-header-inline') ||
           document.querySelector('.t4s-section-header') || document.querySelector('header');
  }

  // Jamais de hauteur en dur : on lit le bord bas du header tel qu'il est
  // MAINTENANT. En haut de page, la barre d'annonce le pousse vers le bas ;
  // une fois la page defilee, il est colle et le bord bas remonte.
  function mesurer() {
    var h = elementHeader();
    var bas = h ? Math.max(0, Math.round(h.getBoundingClientRect().bottom)) : 0;
    racine.style.setProperty('--sc-rech-haut', bas + 'px');
    var vv = window.visualViewport;
    racine.style.setProperty('--sc-rech-vh', Math.round(vv ? vv.height : window.innerHeight) + 'px');
    racine.style.setProperty('--sc-rech-vtop', Math.round(vv ? vv.offsetTop : 0) + 'px');
  }

  function surveiller() {
    mesurer();
    window.addEventListener('resize', mesurer);
    if (window.visualViewport) {
      window.visualViewport.addEventListener('resize', mesurer);
      window.visualViewport.addEventListener('scroll', mesurer);
    }
    var h = elementHeader();
    if (h && 'ResizeObserver' in window) {
      observateur = new ResizeObserver(mesurer);
      observateur.observe(h);
    }
  }

  function cesserDeSurveiller() {
    window.removeEventListener('resize', mesurer);
    if (window.visualViewport) {
      window.visualViewport.removeEventListener('resize', mesurer);
      window.visualViewport.removeEventListener('scroll', mesurer);
    }
    if (observateur) { observateur.disconnect(); observateur = null; }
  }

  /* ------------------------------------------------------------------ */
  /* Ouverture / fermeture                                               */
  /* ------------------------------------------------------------------ */
  function verrouiller() {
    var largeurBarre = window.innerWidth - document.documentElement.clientWidth;
    document.body.classList.add('sc-rech-verrou');
    if (largeurBarre > 0) document.body.style.paddingRight = largeurBarre + 'px';
  }

  function deverrouiller() {
    document.body.classList.remove('sc-rech-verrou');
    document.body.style.paddingRight = '';
  }

  // Le menu mobile (z-index 10050) passerait par-dessus : on le ferme d'abord.
  function fermerMenuMobile() {
    if (!document.documentElement.classList.contains('sc-mnav-verrou')) return false;
    var f = document.querySelector('.sc-mnav__fermer[data-sc-fermer]');
    if (f) { f.click(); return true; }
    return false;
  }

  function loupeVisible() {
    var liens = document.querySelectorAll('a[data-drawer-options*="t4s-search-hidden"], a[href="' + CFG.recherche_url + '"]');
    for (var i = 0; i < liens.length; i++) {
      if (!racine.contains(liens[i]) && liens[i].getBoundingClientRect().width > 0) return liens[i];
    }
    return null;
  }

  function ouvrir(source) {
    if (ouvert) { champ.focus(); return; }
    var menuFerme = fermerMenuMobile();
    declencheur = source && source.getBoundingClientRect().width > 0 ? source : loupeVisible();

    ouvert = true;
    surveiller();
    verrouiller();
    // Le verrou peut deplacer le header (barre de defilement retiree, largeur
    // recalculee) : on mesure UNE FOIS DE PLUS apres l'avoir pose.
    mesurer();
    racine.removeAttribute('inert');
    racine.classList.add('is--ouvert');
    racine.setAttribute('aria-hidden', 'false');

    // Saisie conservee si on rouvre tout de suite ; sinon, etat vide propre.
    if (saisieConservee && Date.now() - fermeLe < CONSERVATION_SAISIE) {
      champ.value = saisieConservee;
    } else {
      champ.value = '';
    }
    rendreEtatVide();
    actualiser();
    evenement('search_open', {});

    // Apres fermeture du menu mobile, qui rend lui-meme le focus a son bouton :
    // on attend qu'il ait fini pour ne pas se faire voler le curseur.
    window.setTimeout(function () { if (ouvert) champ.focus({ preventScroll: true }); }, menuFerme ? 380 : 30);
  }

  function fermer() {
    if (!ouvert) return;
    ouvert = false;
    window.clearTimeout(minuteur);
    saisieConservee = champ.value;
    fermeLe = Date.now();
    racine.classList.remove('is--ouvert');
    racine.setAttribute('aria-hidden', 'true');
    racine.setAttribute('inert', '');
    cesserDeSurveiller();
    deverrouiller();
    // Retour du focus sur la loupe — ou, si l'element d'origine a disparu
    // (entree du menu mobile fermee), sur la loupe du header.
    var cible = declencheur && document.contains(declencheur) && declencheur.getBoundingClientRect().width > 0
      ? declencheur : loupeVisible();
    if (cible && cible.focus) cible.focus({ preventScroll: true });
  }

  /* ------------------------------------------------------------------ */
  /* Evenements                                                          */
  /* ------------------------------------------------------------------ */
  // Toutes les loupes, en phase de capture et avec arret de la propagation :
  // Kalles pose son propre gestionnaire (data-drawer-options) pour ouvrir SON
  // tiroir, et les deux s'ouvriraient l'un sur l'autre. Meme methode que le
  // panier (assets/sylvercar-cart.js). Clic milieu, Ctrl, Cmd, Maj : on ne
  // touche a rien, le visiteur veut un nouvel onglet vers /search.
  var DECLENCHEURS = 'a[href="' + CFG.recherche_url + '"], [data-drawer-options*="t4s-search-hidden"], a.sc-mnav__recherche';

  document.addEventListener('click', function (e) {
    var t = e.target && e.target.closest ? e.target.closest(DECLENCHEURS) : null;
    if (t && !racine.contains(t)) {
      if (e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();
      ouvrir(t);
      return;
    }
    // Le panier s'ouvre par-dessus tout : on rend la main.
    if (ouvert && e.target && e.target.closest && e.target.closest('a[href$="/cart"]')) fermer();
  }, true);

  racine.addEventListener('click', function (e) {
    var cible = e.target;
    if (!cible || !cible.closest) return;

    if (cible.closest('[data-sc-rech-voile]') || cible.closest('[data-sc-rech-fermer]')) { fermer(); return; }

    if (cible.closest('[data-sc-rech-effacer]')) {
      champ.value = '';
      champ.focus();
      actualiser();
      return;
    }

    var lien = cible.closest('[data-sc-evt]');
    if (!lien) return;
    var type = lien.getAttribute('data-sc-evt');
    var terme = champ.value.trim();
    if (type === 'produit') evenement('search_product_click', { search_term: terme, item_handle: lien.getAttribute('data-handle') });
    else if (type === 'besoin') evenement('search_need_click', { need_label: lien.getAttribute('data-besoin'), collection_handle: lien.getAttribute('data-collection') });
    else if (type === 'collection') evenement('search_collection_click', { search_term: terme, source: lien.getAttribute('data-source'), collection_handle: lien.getAttribute('data-collection') });
    else if (type === 'tout') evenement('search_view_all', { search_term: terme });
  });

  champ.addEventListener('input', function () {
    btnEffacer.hidden = !champ.value.length;
    window.clearTimeout(minuteur);
    minuteur = window.setTimeout(actualiser, DELAI_FRAPPE);
  });

  // Entree : page de resultats complete, avec la requete CORRIGEE — une faute
  // de frappe ne doit pas condamner la page de resultats native.
  form.addEventListener('submit', function (e) {
    e.preventDefault();
    var saisie = champ.value.trim();
    if (!saisie) return;
    var requete = corrigerRequete(saisie) || saisie;
    evenement('search_view_all', { search_term: saisie });
    window.location.href = CFG.recherche_url + '?q=' + encodeURIComponent(requete) + '&type=product';
  });

  function liensVisibles() {
    var zone = zoneRes.hidden ? zoneVide : zoneRes;
    return Array.prototype.slice.call(zone.querySelectorAll('a[href]')).filter(function (a) { return a.getBoundingClientRect().width > 0; });
  }

  function focalisables() {
    return Array.prototype.slice.call(racine.querySelectorAll('a[href], button:not([hidden]), input:not([type="hidden"])'))
      .filter(function (el) { return !el.disabled && el.getBoundingClientRect().width > 0; });
  }

  document.addEventListener('keydown', function (e) {
    if (!ouvert) return;

    if (e.key === 'Escape') { e.preventDefault(); fermer(); return; }

    // Piege du focus : la fenetre est modale, Tab ne doit pas filer derriere.
    if (e.key === 'Tab') {
      var f = focalisables();
      if (!f.length) return;
      var premier = f[0], dernier = f[f.length - 1];
      if (e.shiftKey && document.activeElement === premier) { e.preventDefault(); dernier.focus(); }
      else if (!e.shiftKey && document.activeElement === dernier) { e.preventDefault(); premier.focus(); }
      return;
    }

    // Fleches : du champ vers les liens, et entre les liens.
    if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
      var liens = liensVisibles();
      if (!liens.length) return;
      var i = liens.indexOf(document.activeElement);
      if (document.activeElement === champ && e.key === 'ArrowDown') { e.preventDefault(); liens[0].focus(); }
      else if (i !== -1) {
        e.preventDefault();
        if (e.key === 'ArrowDown') liens[Math.min(i + 1, liens.length - 1)].focus();
        else if (i === 0) champ.focus();
        else liens[i - 1].focus();
      }
    }
  });
})();
